<template>
	<div class="uhead f-bct">
		<div class="tit" style="cursor: pointer;" @click="link('/home')">HI 欢迎登录<span>海南省燃气协会燃气从业人员培训教育信息平台</span></div>
		<div class="userBox">
			<div class="userName f-ct" v-if="userType==1">
				<el-image fit="cover" :src="userInfo.member.portrait"></el-image>
				<p>{{userInfo.member.name}}</p>
			</div>
			<div class="userName f-ct" v-if="userType==2">
				<el-image :src="userInfo.company.logo"></el-image>
				<p>{{userInfo.company.companyName}}</p>
			</div>
			<div class="iconBox f-ct">
				<div class="bor"></div>
				<div class="i1" @click="link('/userNews')">
					<el-image :src="require('@/static/icon33.png')"></el-image>
					<div v-if="userInfo.notReadMessageNum" class="new"></div>
				</div>
				<div class="i2">
					<el-image :src="require('@/static/icon34.png')"></el-image>
				</div>
				<div class="i3" @click="loginOut">
					<el-image :src="require('@/static/icon35.png')"></el-image>
				</div>
			</div>
		</div>
		
		
		<!-- 退出登录 -->
		<div class="maskBg" @click="hblout=false" v-if="hblout"></div>
		<div class="subTipsQx" v-if="hblout">
			<el-image class="cha" @click="hblout=false" :src="require('@/static/icon57.png')"></el-image>
			<el-image class="icon" :src="require('@/static/icon102.png')"></el-image>
			<div class="t1">确定要退出登录吗？</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="loginOutF">确定退出</div>
				<div class="b2" @click="hblout=false">我再想想</div>
			</div>
		</div>
		
	</div>
</template>
<script>
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	name: "userHead",
	data(){
		return {
			hblout:false,
		}
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	},
	mounted() {
		console.log(this.userInfo)
	},
	methods:{
		// 退出登录
		loginOut(){
			this.hblout = true
		},
		loginOutF(){
			this.Tips('操作成功','success')
			this.$store.commit('userMsg/tokenC','');
			this.$store.commit('userMsg/userInfoC','');
			this.$store.commit('userMsg/userTypeC',1);
			localStorage.clear();
			setTimeout(()=>{
				this.link('/home')
			},1500)
		},
	}
}
</script>
<style lang="scss">
body{
	background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.uhead{
	margin: 0 40px;
	// width: 100%;
	// width: 1574px;
	height: 88px;
	border-radius: 20px;
	// margin: auto;
	background: #fff;
	padding-left: 30px;
	padding-right: 24px;
	margin-bottom: 24px;
	margin-top: 32px;
	.tit{
		font-size: 20px;
		color: #545964;
		span{
			color: #3B6492;
			padding-left: 9px;
		}
	}
	.userBox{
		width: calc(100% - 620px);
		display: flex;
		align-items: center;
		justify-content: flex-end;
		.userName{
			.el-image{
				width: 34px;
				height: 34px;
				border-radius: 50%;
				margin-right: 12px;
			}
			p{
				font-size: 18px;
			}
		}
	}
	.iconBox{
		margin-left: 32px;
		.bor{
			width: 2px;
			height: 18px;
			background: #B9C1CB;
		}
		.el-image{
			width: 28px;
			height: 28px;
		}
		.i1{
			margin-left: 32px;
			position: relative;
			.new{
				width: 8px;
				height: 8px;
				position: absolute;
				border-radius: 50%;
				top: 2px;
				right: 2px;
				background: #FA5555;
			}
		}
		.i2{
			margin-left: 32px;
		}
		.i3{
			margin-left: 32px;
		}
	}
}

.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTipsQx{
	position: fixed;
	width: 420px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 90px;
		height: 90px;
	}
	.icon1{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 115px;
		height: 115px;
	}
	.t3{
		font-size: 18px;
		color: #2F3541;
		font-weight: 600;
		text-align: center;
		margin-top: 10px;
	}
	.t1{
		font-size: 18px;
		color: #2F3541;
		font-weight: 600;
		text-align: center;
		margin-top: 25px;
	}
	.t2{
		font-size: 14px;
		color: #7D7D89;
		padding: 0 26px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
	}
	.btnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 120px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>